import Vue from 'vue'
import App from './App.vue'
import router from './router';
import api from './api/api';
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
Vue.config.productionTip = false
Vue.prototype.$api = api
import { EventBus } from './eventBus';
Vue.prototype.$eventBus = EventBus;
import { Tabbar, TabbarItem, Swipe, SwipeItem,Lazyload,Field,Button,Cascader,Popup,Picker,Uploader} from 'vant';
import 'vant/lib/index.css'; // 引入 Vant 的全局样式
// 全局注册 Vant 的组件
Vue.use(ElementUI);
Vue.use(Tabbar);
Vue.use(TabbarItem);
Vue.use(Swipe);
Vue.use(SwipeItem);
Vue.use(Lazyload);
Vue.use(Field);
Vue.use(Button);
Vue.use(Cascader);
Vue.use(Button);
Vue.use(Popup);
Vue.use(Picker);
Vue.use(Uploader);
(function() {
    function setRemUnit() {
        const docEl = document.documentElement;
        const width = docEl.clientWidth;
        const rem = width / 100; // 2000px 设计稿对应 100rem，1rem = 20px
        docEl.style.fontSize = rem + 'px';
    }

    setRemUnit();
    window.addEventListener('resize', setRemUnit);
})();

new Vue({
  router,
  render: h => h(App),
}).$mount('#app')
